import style from './index.module.css';

import React from "react";
import PropTypes from "prop-types";
import {flag_icon_default_shape, flag_icon_class_prefix, flag_icon_squared_class} from "../../../../config";
import {FLAG_SHAPE} from "../../../const/global";
import {convertCountryCode} from "../../../helpers/country";

/**
 * Flag component
 * @note This component uses GUI config (see '/src/config/gui' file) to determine some default options.
 */
function Flag({
	country, shape = flag_icon_default_shape, className,
	countryPrefix = flag_icon_class_prefix, squaredClassName = flag_icon_squared_class, ...otherProps
}) {
	const countryCode = convertCountryCode(country, 'ISO2');
	
	return (
		countryCode ?
			<span
				className={
					`${countryPrefix}${countryCode.toLowerCase()} flag` +
					(shape === FLAG_SHAPE.SQUARE || shape === FLAG_SHAPE.CIRCLE ? ` ${squaredClassName}` : '') +
					(shape === FLAG_SHAPE.ELLIPSE || shape === FLAG_SHAPE.CIRCLE ? ' ' + style['round'] : '') +
					(className ? ` ${className}` : '')
				}
				{...otherProps}
			/>
			: null
	);
}

/**
 * Define component's own props that can be passed to it by parent components
 */
Flag.propTypes = {
	// Case-insensitive ISO 3166-1-alpha-2 or ISO 3166-1-alpha-2 code of a country
	// @example 'rs', 'RS', 'usa', 'SRB', ...
	// @link https://www.iso.org/obp/ui/#search
	country: PropTypes.string,
	// Flag shape
	// @see 'FLAG_SHAPE' global const in '/src/core/const/global.js' file.
	shape: PropTypes.oneOf(Object.keys(FLAG_SHAPE)),
	// Flag element CSS class
	className: PropTypes.string,
	// Flag element CSS class prefix for country
	countryPrefix: PropTypes.string,
	// Flag element CSS class used for squared flags (if supported by flags package or icon set)
	squaredClassName: PropTypes.string
};

export default Flag;